export { default } from './Accordion';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Accordion/index.js
// module id = 298
// module chunks = 0